import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["menstrual-cycle-and-running"]!;

export function Body() {
  return (
    <>
      <p>
        Should you train differently depending on where you are in your menstrual cycle? The
        idea has become popular, but what does the research say? A large meta-analysis looked at
        all the available studies.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers collected 78 studies that measured exercise performance in women with regular
        cycles in two or more phases of the cycle. They compared performance in the early
        follicular phase, the days around and just after the start of a period, with the other
        phases.
      </p>

      <h2>What they found</h2>
      <p>
        Performance might be slightly lower in the early follicular phase, but the effect was
        trivial. The differences between studies were large, and the quality of the evidence was
        rated low.
      </p>
      <p>
        Because of this, the researchers concluded that general guidelines for training across the
        cycle cannot be given. They recommended a personal approach based on how each woman
        responds.
      </p>

      <h2>What it means for you</h2>
      <p>
        There is no need to plan your training around your cycle unless you notice that it
        affects you. If certain days regularly feel harder, it is reasonable to make a session
        easier or move it. Many women run well throughout the cycle, including on race day.
      </p>
      <p>
        Severe pain, very heavy bleeding or missed periods are worth discussing with a doctor,
        especially if you train a lot.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The studies included women with regular cycles, not women using hormonal contraception.
        Most studies were small, and performance was measured in many different ways.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training asks how you feel before a session and how hard it felt afterwards. If you
        are more tired on some days, say so, and the next sessions take it into account.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          McNulty et al. (2020), The effects of menstrual cycle phase on exercise performance in
          eumenorrheic women: a systematic review and meta-analysis.{" "}
          <a href="https://doi.org/10.1007/s40279-020-01319-3">Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
